import React from 'react';
import { Grid, Button, Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { Close } from '@material-ui/icons';
import { I18nContext } from 'translations';
import styles from './style';

// Lists a route's chat threads — one per prepackage (specs/007-chat-por-paquete/), never
// grouped by company: two packages of the same company are two separate rows, each
// carrying its own reference, customer and delivery address so they read as different
// deliveries. Purely presentational: it neither fetches nor opens a WebSocket — the caller
// hands it the threads (already scoped to what the session may see) and gets told which
// one was picked. BookingChat is the one that talks to the selected thread.
function DeliveryRouteChatList({ classes, threads, selectedPrePackageId, onSelect, onClose }) {
  const { translate } = React.useContext(I18nContext);
  const list = threads || [];

  return (
    <div className={classes.boxList}>
      <div className={classes.header}>
        <Grid container alignItems="center">
          <Typography variant="subtitle2">
            {translate('app.booking.chat.routeChatsTitle')}
          </Typography>
        </Grid>
        <Button color="primary" className={classes.btnClose} onClick={onClose}>
          <Close />
        </Button>
      </div>
      <div className={classes.list}>
        {list.length === 0 && (
          <Typography className={classes.empty}>
            {translate('app.booking.chat.routeChatsEmpty')}
          </Typography>
        )}
        {list.map((thread) => {
          const subtitle = [thread.customer_name, thread.delivery_address].filter(Boolean).join(' · ');
          const isSelected = selectedPrePackageId && thread.pre_package_id === selectedPrePackageId;

          return (
            <div
              key={thread.pre_package_id}
              className={`${classes.row} ${isSelected ? classes.rowSelected : ''}`}
              onClick={() => onSelect(thread)}
              role="button"
              tabIndex={0}
            >
              <Typography className={classes.reference}>
                {`#${thread.reference || thread.prepackage_identification}`}
                {!!thread.badge && <span className={classes.badge}>{thread.badge}</span>}
              </Typography>
              {subtitle && <Typography className={classes.subtitle}>{subtitle}</Typography>}
              {thread.company_name && (
                <Typography className={classes.company}>{thread.company_name}</Typography>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default withStyles(styles)(DeliveryRouteChatList);
